import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {Observable} from 'rxjs';
import {LayoutConfigService} from '@core/services/layout-config.service';
import {Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {CommonState, getLocation} from '@store/common';
import {AppConfig} from '@core/services/app-config.service';
import {UserProfileService} from './user-profile/user-profile.service';
import {SideBarService} from '@core/services/layout/side-bar.service';
import {SideBarTypes} from '@store/layout';
import {Locations} from '@shared/enums/locations.enum';
import {getLineageCount} from '@store/lineage';
import {MatTooltip} from '@angular/material/tooltip';
import { ModuleUtilsService } from '@core/services/module-utils.service';

@Component({
    selector: 'm-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit, AfterViewInit {
    location$: Observable<string>;
    isMonitorDisplay: boolean = false;
    public locations: typeof Locations = Locations;
    selectedConnections$: Observable<string>;
    hasUserMadeChanges: boolean = false;
    tooltipText: string = 'Metadata Connections';
    private currentLocation: string;
    private previousLocation: string;
    private autoTooltipShown: boolean = false;
    @ViewChild('connectionsTooltip') connectionsTooltip: MatTooltip;
    private warningActive: boolean = false;

    private isE2EColumnDetail(): boolean {
        return this.currentLocation === this.locations.e2eColumn && this.router?.url?.startsWith('/e2e-column/');
    }

    constructor(
        private appConfig: AppConfig,
        private layoutConfigService: LayoutConfigService,
        private router: Router,
        private commonStore: Store<CommonState>,
        private userProfileService: UserProfileService,
        private sideBarService: SideBarService,
        private store: Store<any>,
        private moduleUtilsService: ModuleUtilsService,
    ) {
        this.location$ = commonStore
            .pipe(
                select(getLocation)
            );
    }

    ngOnInit(): void {
        this.location$
            .subscribe(loc => {
                const newLocation = <string>this.moduleUtilsService.getLocationPreferredKey(loc);
                if (newLocation === this.locations.e2eColumn && this.previousLocation !== this.locations.e2eColumn) {
                    this.autoTooltipShown = false;
                }
                this.currentLocation = newLocation;
                if (!this.autoTooltipShown
                    && this.warningActive
                    && this.isE2EColumnDetail()
                    && this.connectionsTooltip) {
                    this.connectionsTooltip.show();
                    setTimeout(() => this.connectionsTooltip?.hide(), 3000);
                    this.autoTooltipShown = true;
                }
                this.previousLocation = newLocation;
            });
        this.selectedConnections$ = this.store.pipe(select(getLineageCount));
        this.selectedConnections$.subscribe((selectedConnections: string) => {
            if (selectedConnections.includes('/')) {
                const [selected, total] = selectedConnections.split('/').map(num => parseInt(num.trim(), 10));
                this.hasUserMadeChanges = selected < total;
                this.warningActive = this.hasUserMadeChanges;
                this.tooltipText = this.hasUserMadeChanges
                    ? `Metadata Connections\n⚠️ Not all metadata connections selected`
                    : `Metadata Connections`;
                // Auto-show warning once on E2E Column page
                if (!this.autoTooltipShown
                    && this.warningActive
                    && this.isE2EColumnDetail()
                    && this.connectionsTooltip) {
                    // Show immediately and hide after a short delay
                    this.connectionsTooltip.show();
                    setTimeout(() => this.connectionsTooltip?.hide(), 3000);
                    this.autoTooltipShown = true;
                }
            } else {
                this.hasUserMadeChanges = true;
                this.warningActive = false;
            }
        });
    }

    ngAfterViewInit(): void {
        // If the warning is already active on init and we're on e2eColumn, auto-show once
        setTimeout(() => {
            if (!this.autoTooltipShown
                && this.warningActive
                && this.isE2EColumnDetail()
                && this.connectionsTooltip) {
                this.connectionsTooltip.show();
                setTimeout(() => this.connectionsTooltip?.hide(), 3000);
                this.autoTooltipShown = true;
            }
        });
    }

    openSideBar() {
        this.sideBarService.open(SideBarTypes.connections);
    }
}
